import { ERouteNames } from 'Routes/types';

// NOTICE: put route here
export const PAGES_WITHOUT_NAVIGATION_BAR: string[] = [];
